import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import logo from './HuntLogo.gif'; 

const Header = ({ logAction, currentStep }) => {
    const logoStyle = {
        width: 'auto'
    };

    const headerStyle = {
        height: '60px',             
        backgroundColor: '#fff',
    };

    return (
        <header className="d-flex justify-content-between align-items-center" style={headerStyle}>
            <Link to="/elift"><img src={logo} alt="Logo" style={logoStyle} /></Link>
            {/*<LanguageSelector />*/}
            <LanguageSelector logAction={logAction} currentStep={currentStep} />
        </header>
    );
};

export default Header;